var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportDetails_1;
// eslint-disable-next-line import/no-duplicates
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './importConfigs/importConfig'; // force import for JsonSchema
import { ImportOperation, ImportStatus } from './importTask';
const ImportDetailsSchema = {
    $id: 'urn:wisepipe-common-data:ImportDetails',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        importID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        operation: { type: 'string', enum: Object.values(ImportOperation) },
        status: { type: 'string', enum: Object.values(ImportStatus) },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        discoveryID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        connectionID: { type: 'string', uid: 9 },
        firstDataSourceID: { type: 'string', uid: 9 },
        error: { type: 'object' },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        rowsProcessed: { type: 'number', minimum: 0 }
    },
    // status determines which fields are required
    if: { properties: { status: { const: ImportStatus.Completed } } },
    then: { required: ['endTime'] },
    else: {
        if: { properties: { status: { const: ImportStatus.Failed } } },
        then: { required: ['error', 'endTime'] },
        else: {
            if: { properties: { status: { const: ImportStatus.Cancelled } } },
            then: { required: ['endTime'] }
        }
    },
    required: ['userID', 'importID', 'name', 'operation', 'status', 'config', 'originID', 'startTime', 'progress']
};
let ImportDetails = ImportDetails_1 = class ImportDetails {
    constructor(importTask, name, originID, config, discoveryID, streamID, connectionID, progress, rowsProcessed = undefined) {
        this.userID = importTask.userID;
        this.importID = importTask.importID;
        this.firstDataSourceID = importTask.firstDataSourceID;
        this.operation = importTask.operation;
        this.status = importTask.status;
        this.startTime = importTask.startTime;
        this.endTime = importTask.endTime;
        this.error = importTask.error;
        this.name = name;
        this.config = config;
        this.originID = originID;
        this.discoveryID = discoveryID;
        this.streamID = streamID;
        this.connectionID = connectionID;
        this.progress = progress;
        this.rowsProcessed = rowsProcessed;
        JSON.validate(this, ImportDetails_1);
    }
    static sort(importDetails) {
        // Sort all imports by status
        importDetails.sort((a, b) => {
            // (status = RUNNING) > (status = FAILED | COMPLETED)
            if (a.status === ImportStatus.Running && b.status !== ImportStatus.Running) {
                return -1;
            }
            if (b.status === ImportStatus.Running && a.status !== ImportStatus.Running) {
                return 1;
            }
            // Sort by startTime for everything else
            return a.startTime > b.startTime ? -1 : 1;
        });
    }
};
ImportDetails.UPLOAD_DISCOVERY_CHECKPOINT = 0.2;
ImportDetails.EXTRACT_TO_CSV_CHECKPOINT = 0.8;
ImportDetails.CSV_TO_PARQUET_CHECKPOINT = 1;
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ImportDetails.prototype, "startTime", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ImportDetails.prototype, "endTime", void 0);
ImportDetails = ImportDetails_1 = __decorate([
    JsonSchema(ImportDetailsSchema)
], ImportDetails);
export { ImportDetails };
//# sourceMappingURL=importDetails.js.map